/* eslint-disable */
jQuery(function($) {

    let CepSearch = {

        init: function() {
            this.autoFillCepOnChange('billing');
            this.autoFillCepOnChange('shipping');

            if ($('#billing_postcode').val() != '') {
                this.autoFillCep('billing');
            }
        },

        clearFields: function(field) {
            $('input[name=' + field + '_address_1]').val('');
            $('input[name=shipping_neighborhood]').val('');
            $('input[name=' + field + '_city]').val('');
            $('select[name=' + field + '_state]').val('');
        },


      updateCountry: function(){
        let select = $('#billing_state'),
            novoValor =  $('#billing_state_mask').val()
            textoOpcao = '';

        if (!select.find(`option[value="${novoValor}"]`).length) {
            select.append(new Option(textoOpcao, novoValor, true, true));
        }
      },


        autoFillCep: function (field) {
            if (field === 'billing' && $('#' + field + '_postcode').length) {
                var cep = $('#' + field + '_postcode').val().replace(/[^0-9]/, '');
                if (cep !== '' && 8 === cep.length) {
                    $.getJSON('https://viacep.com.br/ws/' + cep + '/json/?callback=?', function (dados) {
                        if (!('erro' in dados)) {

                            $('input[name=' + field + '_address_1]').val(dados.logradouro);
                            $( "#billing_address_1_field" ).removeClass( "woocommerce-invalid-required-field").removeClass('woocommerce-invalid');
                            $('input[name=billing_address_1]').closest('.form-row').addClass('show-label');
                            $('input[name=shipping_neighborhood]').val(dados.bairro);
                            $('input[name=shipping_neighborhood]').closest('.form-row').addClass('show-label');
                            $('input[name=' + field + '_city]').val(dados.localidade);
                            $( "#billing_city_field" ).removeClass( "woocommerce-invalid-required-field").removeClass('woocommerce-invalid');
                            $('input[name=billing_city]').closest('.form-row').addClass('show-label');
                            $('#' + field + '_state_mask option:selected').prop('selected', false).change();
                            $('#' + field + '_state_mask option[value="' + dados.uf + '"]').prop('selected', 'selected').change();
                            $('#' + field + '_state option:selected').prop('selected', false).change();
                            $('#' + field + '_state option[value="' + dados.uf + '"]').prop('selected', 'selected').change();
                            $('select[name=billing_state_mask]').closest('.form-row').addClass('show-label');
                            document.getElementById('billing_country').setAttribute('value', 'BR');
                            CepSearch.updateCountry();
                            
                            $('#erro-cep').fadeOut('slow');
                        } else {
                            CepSearch.clearFields();
                            $('#erro-cep').fadeOut('slow');
                            $('#' + field + '_postcode')
                                .after(
                                    '<div id="erro-cep" class="message-container container medium-text-center">' +
                                    'CEP não encontrado, preencha as informações manualmente' +
                                    '</div>');
                        }
                    });
                }
            }
        },

        autoFillCepOnChange: function(field) {
            $(document.body).on('input', '#' + field + '_postcode', function(e) {
                var cep = $(this).val().replace(/[^0-9]/, '');
                if (cep !== '' && cep.length === 8) {
                    CepSearch.autoFillCep(field);
                }
            });
        }
    };

    CepSearch.init();
});
